<mat-form-field fxFlex class="field-full-width">
    <mat-label>{{label}}</mat-label>
    <input type="text"
      #textInput
      matInput
      placeholder="{{label}}"
      [matAutocomplete]="auto"
      [formControl]="searchUserCtrl">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayUser" panelWidth="350px">
      <mat-option *ngIf="isLoading">Loading...</mat-option>
      <ng-container *ngIf="!isLoading">
        <mat-option *ngFor="let user of filteredUsers" [value]="user" (click)="selectUser(user)" [style]="style()">
          <app-user-list-row [user]="user" [mode]="mode"></app-user-list-row>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
</mat-form-field>